"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewItemSchema = exports.SuggestedValueSchema = exports.ReviewQuestion = exports.TriagedAnchorTallySchema = exports.TriagePath = exports.ScoredCandidateSchema = exports.CandidateTallySchema = exports.MEMBERSHIP_COLUMN = exports.AnchorSchema = exports.FieldAnchorSchema = exports.RowAnchorSchema = exports.AnchorKind = void 0;
exports.anchorKey = anchorKey;
const z = require("zod");
var AnchorKind;
(function (AnchorKind) {
    AnchorKind["Row"] = "row";
    AnchorKind["Field"] = "field";
})(AnchorKind || (exports.AnchorKind = AnchorKind = {}));
exports.RowAnchorSchema = z.object({
    kind: z.literal(AnchorKind.Row),
    rowKey: z.string(),
});
exports.FieldAnchorSchema = z.object({
    kind: z.literal(AnchorKind.Field),
    rowKey: z.string(),
    column: z.string(),
});
exports.AnchorSchema = z.discriminatedUnion('kind', [
    exports.RowAnchorSchema,
    exports.FieldAnchorSchema,
]);
function anchorKey(anchor) {
    return anchor.kind === AnchorKind.Field ? `${anchor.rowKey}\x1F${anchor.column}` : `${anchor.rowKey}\x1F`;
}
exports.MEMBERSHIP_COLUMN = '__membership__';
exports.CandidateTallySchema = z.object({
    value: z.unknown().optional(),
    normalizedValue: z.string(),
    voteCount: z.number(),
    proposedBy: z.string().array(),
});
exports.ScoredCandidateSchema = exports.CandidateTallySchema.extend({
    confidence: z.number(),
    confidenceRationale: z.string().optional(),
    denominator: z.number().optional(),
});
var TriagePath;
(function (TriagePath) {
    TriagePath["AutoAccept"] = "auto_accept";
    TriagePath["ExpertReview"] = "expert_review";
})(TriagePath || (exports.TriagePath = TriagePath = {}));
exports.TriagedAnchorTallySchema = z.object({
    anchor: exports.AnchorSchema,
    triagePath: z.nativeEnum(TriagePath),
    candidates: exports.ScoredCandidateSchema.array(),
    resolved: z.unknown().optional(),
});
var ReviewQuestion;
(function (ReviewQuestion) {
    ReviewQuestion["ShouldExist"] = "should_exist";
    ReviewQuestion["SpecifyValue"] = "specify_value";
})(ReviewQuestion || (exports.ReviewQuestion = ReviewQuestion = {}));
exports.SuggestedValueSchema = z.object({
    value: z.unknown().optional(),
    voteCount: z.number(),
    confidence: z.number(),
    confidenceRationale: z.string().optional(),
});
exports.ReviewItemSchema = z.object({
    anchor: exports.AnchorSchema,
    question: z.nativeEnum(ReviewQuestion),
    suggestedValues: exports.SuggestedValueSchema.array(),
});
//# sourceMappingURL=consensus.types.js.map